/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Grant_CreateUpdateGrantDto } from '../models/Wealthlane_AwardService_Dtos_Grant_CreateUpdateGrantDto';
import type { Wealthlane_AwardService_Dtos_Grant_PlanTypeDto } from '../models/Wealthlane_AwardService_Dtos_Grant_PlanTypeDto';
import type { Wealthlane_AwardService_Grant_Grant } from '../models/Wealthlane_AwardService_Grant_Grant';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GrantLegacyService {

    /**
     * @param taskId
     * @param sendHeartBeatMaxPercentage
     * @param percentage
     * @param stage
     * @param status
     * @param requestType
     * @param error
     * @param completionTime
     * @returns number OK
     * @throws ApiError
     */
    public static postApiAwardApiAppGrantLegacySendHeartBeat(
        taskId: string,
        sendHeartBeatMaxPercentage?: number,
        percentage?: number,
        stage?: string,
        status?: string,
        requestType?: number,
        error?: string,
        completionTime?: string,
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/grant-legacy/send-heart-beat/{taskId}',
            path: {
                'taskId': taskId,
            },
            query: {
                'sendHeartBeatMaxPercentage': sendHeartBeatMaxPercentage,
                'percentage': percentage,
                'stage': stage,
                'status': status,
                'RequestType': requestType,
                'error': error,
                'completionTime': completionTime,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param tenantId
     * @param companyId
     * @param userId
     * @param requestBody
     * @returns Wealthlane_AwardService_Grant_Grant OK
     * @throws ApiError
     */
    public static postApiAwardApiAppGrantLegacyGrant(
        tenantId?: string,
        companyId?: string,
        userId?: string,
        requestBody?: Wealthlane_AwardService_Dtos_Grant_CreateUpdateGrantDto,
    ): CancelablePromise<Wealthlane_AwardService_Grant_Grant> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/grant-legacy/grant',
            query: {
                'tenantId': tenantId,
                'companyId': companyId,
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param tenantId
     * @param userId
     * @param requestType
     * @param requestBody
     * @returns Wealthlane_AwardService_Grant_Grant OK
     * @throws ApiError
     */
    public static putApiAwardApiAppGrantLegacyGrant(
        tenantId?: string,
        userId?: string,
        requestType?: number,
        requestBody?: Wealthlane_AwardService_Dtos_Grant_CreateUpdateGrantDto,
    ): CancelablePromise<Wealthlane_AwardService_Grant_Grant> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/grant-legacy/grant',
            query: {
                'tenantId': tenantId,
                'userId': userId,
                'requestType': requestType,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param planId
     * @returns Wealthlane_AwardService_Dtos_Grant_PlanTypeDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppGrantLegacyPlanTypesByPlanId(
        planId: string,
    ): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Grant_PlanTypeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/grant-legacy/plan-types-by-plan-id/{PlanId}',
            path: {
                'PlanId': planId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
